import { CancelReason, PaymentTab } from './types';

/** Landing page that hosts the "book a demo" form every contact-sales link opens. */
export const CONTACT_SALES_URL = `${process.env.REACT_APP_LANDING_URL}/book-demo`;

/** Panes of the cards / billing history box, in display order. */
export const PAYMENT_TABS: { id: PaymentTab; title: string }[] = [
    { id: 'Cards', title: 'Your cards' },
    { id: 'History', title: 'Billing History' },
];

/** Subscriptions in these states owe money, so they are paid for instead of upgraded. */
export const UNPAID_STATUSES = ['past_due', 'unpaid', 'incomplete'];

/** Only a subscription in one of these states can still be canceled. */
export const CANCELABLE_STATUSES = ['active', 'incomplete', 'past_due', 'unpaid', 'trialing'];

/** A seat can never be bought beyond this total, sales has to be involved. */
export const MAX_MEMBER_SEATS = 5;

/** Reasons offered before a subscription is canceled. */
export const CANCELLATION_REASONS: CancelReason[] = [
    { id: 1, text: 'I don’t have time to use it right now' },
    { id: 2, text: 'It feels too expensive for my current needs' },
    { id: 3, text: 'I’ve already hired or completed my project' },
    { id: 4, text: 'I’m not sure how to get the most out of it' },
    { id: 5, text: 'It’s not what I expected' },
    { id: 6, text: 'I was only trying it temporarily' },
    { id: 7, text: 'I plan to return and subscribe later' },
    { id: 8, text: 'Other' },
];

/** "Other" asks for a comment, which is what gets reported as the reason. */
export const OTHER_REASON_ID = 8;

/** Toast copy used when a payment request fails without telling us why. */
export const GENERIC_ERROR = 'Something went wrong,Please try again...';
